import React from "react";

const Avatar = ({ Name }) => {
  return (
    <React.Fragment>
      <img
        src={`https://api.dicebear.com/7.x/adventurer/svg?seed=${Name}&flip=true&radius=25&skinColor=ecad80,f2d3b1&backgroundColor=b6e3f4,c0aede,d1d4f9,ffd5dc,ffdfbf,transparent`}
        alt="avatar"
        width="100px"
        height="100px"
        style={{
          borderRadius: "50%",
          filter: "drop-shadow(0px 0px 10px rgba(128,128,128,0.75))",
        }}
      />
    </React.Fragment>
  );
};

export default Avatar;
